import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=2c07ba54&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=2c07ba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07ba54",
  null
  
)

export default component.exports